import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.dev';
import { JOB_STATUS, JOB_TYPE } from '../../@core/models/enums';
import { IUser } from '../../@core/models/model';
import { BaseService } from '../../@core/services/base.service';
import { JOB_FILTER_STATUS } from '../../@shared/components/notifications/notifications.component';
import { IContract } from '../models/contract-management.model';
import { IGeotechnicalAnalysis } from '../../features/geotechnical-analysis/services/geotechnical-analysis.service';



export interface IJob extends Document {
    readonly _id: string
    item: IContract | IGeotechnicalAnalysis | null,
    type: JOB_TYPE,
    status: JOB_STATUS,
    user: string | IUser,
    metadata: {
        contractId?: string,
        templateId?: string,
        analysisName?: string,
        geotechnicalAnalysisId?: string,
    },
    createdAt?: Date,
    updatedAt?: Date
}

export enum JOB_GROUP {
    GEOTECHNICAL_ANALYSIS = 'GEOTECHNICAL_ANALYSIS',
    CONTRACT = 'CONTRACT',
    OTHER = 'OTHER',
}

export interface IJobGroup {
    groupId: string;
    groupLabel: string;
    groupType: JOB_GROUP;
    jobs: IJob[];
}

export interface IJobGroupedResponse {
    groups: IJobGroup[];
    total: number;
}

export type JobFilters = {
    selected: JOB_FILTER_STATUS;
    skip: number;
    limit: number;
    project?: string;
    allowedJobs?: JOB_TYPE[];
    groupByItems?: boolean;
    search?: string;
    jobType?: JOB_TYPE;
    status?: JOB_STATUS;
    dateFrom?: string;
    dateTo?: string;
};


@Injectable({ providedIn: 'root' })
export class JobService extends BaseService {

    apiUrl = environment.apiUrl + '/job';

    constructor(protected override http: HttpClient) { super(http); }

    getJobs(jobFilters: JobFilters) {
        return this.post<IJob[]>(this.apiUrl, jobFilters);
    }

    getJobsGrouped(jobFilters: Omit<JobFilters, 'groupByItems'>) {
        return this.post<IJobGroupedResponse>(this.apiUrl, { ...jobFilters, groupByItems: true });
    }

    cancelJob(jobId: string) {
        return this.put(this.apiUrl, { jobId })
    }
}
